<template>
  <div class="header">
    <div class="cont">
      <div class="logo-box">
          <a target="_blank" href="../../../../escopemap/content/cn/main/main.html" title="易景空间三维场景首页">
            <img style="width:50%;" src="../../public/images/icon/logo.png"/>
            <span style="margin-left:10px;font-size: 16px;">易景空间数据中台</span>
          </a>
           
      </div>
      <div class="back-list">
      </div>
      <div class="title-box">
         <div class="title-btn" @click="helpClick">
            <img  src="../../public/images/icon/help.png"/>
            <span>帮助文档</span>
         </div>
    
        <div class="user-box">
          <div class="m-a" @mouseover="userMouseOver()" @mouseleave="userMouseLeave()">
            <div class="img">
              <img src="../assets/images/icon/touxiang.png" alt="用户头像">
            </div>
            <div class="usercode">{{userName}}</div>
            <div  v-if="showloginMenu" class="list-btn-menu">
                <div class="exit-login">
                    <div @click="exitLogin">退出登录</div>
                    <div @click="backUserCenter">会员中心</div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyHeader',
  data() {
    return {
      showloginMenu:false,
      userName:'',
      userData: {
        oldpass: "",
        pass: "",
        checkPass: "",
      }
    }
  },
  methods: {
    myProjectClick(){
        this.$store.state.mainLeftMenu=2;
        if(this.$route.name!='list') this.$router.push({name: 'list'});
        else{
          this.$router.go(0);
        }
    },
    beaconList(){
        this.$store.state.mainLeftMenu=3;
        if(this.$route.name!='beacon') this.$router.push({name: 'beacon'});
        else{
          this.$router.go(0);
        }
    },
    userMouseOver(){
        this.showloginMenu=true;
    },
    userMouseLeave(){
        this.showloginMenu=false;
    },
    exitLogin(){
       //清除cookies
        clearCookie();
        window.location.href=this.api.loginHtmlUrl;
    },
    backUserCenter(){
        window.open("https://www.esmap.cn/esmapv/content/cn/member/index.html");
    },
    helpClick(){
      window.open("https://www.esmap.cn/docs/esmapdc/index.html");
    }
  },
  created() {
    this.userName=getCookieV("usercode1");
  },
  computed: {

  },
}
</script>

<style lang="scss">
  .header {
    height: 60px;
    line-height: 60px;
    background: #FFFFFF;
    color: #333333;
    font-size:14px;
    .logo-box {
      position: relative;
      top: 0;
      left: 0;
      width: 440px;
      height: 60px;
      box-sizing: border-box;
      padding-left:10px;
    }
    .logo-box a{
      display: flex;
      // justify-content: center;
      align-items: center;
      height: 100%;
      text-decoration: none;
      color: #000;
    }
    .back-list{
        position: absolute;
        top: 0;
        left: 220px;
        display: flex;
    }
    .title-box{
        position: absolute;
        top: 0;
        right: 0px;
        display: flex;
    }
    .title-btn{
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 30px;
        cursor: pointer;
    }
    .title-btn span:hover{
      color:#005FFD;
    }
    .usercode:hover{
      color:#005FFD;
    }
    .title-btn img{
        height:18px;
        width:18px;
        margin-right:5px
    }
    .user-box:hover {
      .login {
        display: block !important;
      }
    } 
    .user-box {
      position: relative;
      top: 0;
      right: 0;
      color: #FFFFFF;
      height: 60px;
      .m-a {
        display: flex;
        color: #303133;
        justify-content: space-between;
        padding: 0 30px;
        justify-content: space-between;
        align-items: center;
        position: relative;
        height: 100%;
        .img {
          width:33px;
          height:33px;
          background:rgba(255,255,255,1);
          border-radius:50%;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 10px;
        }
        
        .login {
          display: none;
          position: absolute;
          z-index: 2;
          color:#909399;
          background: #FFFFFF;
          top: 60px;
          left: 0;
          border-top: 1px solid #FFFFFF;
          li {
            height: 60px;
            line-height: 60px;
            padding: 0 13px;
            cursor: pointer;
          }
          li:hover {
            background:#2486FF;
            color: #fff;
          }
        }
      }
    }
    .cont{
        user-select: none;
    }
    .exit-login{
        position: fixed;
        width: 95px;
        // height: 41px;
        top: 60px;
        right: 5px;
        flex-wrap: wrap;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fff;
        z-index:30;
        cursor: pointer;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 2, 0.2);
    }
    .exit-login div{
        height: 40px;
        display: flex;
        align-items: center;
    }
  }
</style>